module.exports = __webpack_public_path__ + "static/media/Stay_at_home_requirements_delay.64a4360e.svg";